import * as React from "react";

const IconPaginationLargeRight: React.FC = () => (
    <svg
        width="11px"
        height="20px"
        viewBox="0 0 11 20"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <polygon
            fill="currentColor"
            points="11 10 10.394 10.619 1.817 19.381 1.212 20 0 18.762 .606 18.143 8.577 10 .606 1.857 0 1.238 1.212 0 1.817 .619 10.394 9.381 11 10"
        />
    </svg>
);

export default React.memo(IconPaginationLargeRight);
